import Vue from 'vue';
import VueSocket from 'vue-socket.io-extended';
import SocketIO from 'socket.io-client';

Vue.use(VueSocket, SocketIO(process.env.VUE_APP_BACKEND + "/api/"))